const plans = [
	{
		type: "free",
		features: ["4 page examples", "Community support", "Free design assets (Figma)"],
		link: "https://mui.com/store/items/carpatin-dashboard",
		linkText: "Try the Demo",
	},
	{
		type: "pro",
		features: ["30 page examples", "Premium support", "Pro design assets (Figma)", "Authentication with Amplify , Auth0 , Firebase and JWT", "Data states", "Built with Mocked API"],
		link: "https://mui.com/store/items/carpatin-dashboard",
		linkText: "Purchase Pro Version",
	},
];

export default plans;
